import { PasswordFormCondition } from '@elearning-platform/ui';
import { TransProps, useTranslation } from 'react-i18next';

import { hasNumberRegexp, lowercaseRegexp, maxRepeatedCharsRegexp, minLengthRegexp, specialCharRegexp, uppercaseRegexp } from '../regexps';

export const usePasswordConditions: () => PasswordFormCondition[] = (): PasswordFormCondition[] => {
  const { t }: TransProps<never> = useTranslation();

  return [
    { text: t('competence.app.passwordForm.condition.minLength', { data: 12 }), condition: minLengthRegexp },
    { text: t('competence.app.passwordForm.condition.minNumbers', { data: 1 }), condition: hasNumberRegexp },
    { text: t('competence.app.passwordForm.condition.minLowercase', { data: 1 }), condition: lowercaseRegexp },
    { text: t('competence.app.passwordForm.condition.minUppercase', { data: 1 }), condition: uppercaseRegexp },
    { text: t('competence.app.passwordForm.condition.minSpecialChars', { data: 1 }), condition: specialCharRegexp },
    { text: t('competence.app.passwordForm.condition.maxRepeatedChars', { data: 3 }), condition: maxRepeatedCharsRegexp },
  ];
};
